/**
 * API calls for the requests module
 */
import {
  getApiV5FirmsAppConnectionsDmsFileExportsStatus,
  postApiV5FirmsAppConnectionsDmsFileExports,
} from '@liscio/api';

import type { GruntWorxExportEndpoints } from '../components/RequestsTableCells/RowMenuCell/hooks/useGruntWorxExport';

/**
 * GruntWorx export through the shared DMS file export endpoint: one workflow
 * request (by the uuid `startExport` receives), or the given Files documents.
 */
export const dmsGruntWorxExportEndpoints = (
  source: 'Request' | 'Document',
  documentUuids?: string[]
): GruntWorxExportEndpoints => ({
  export: async (requestUuid) => {
    const result = await postApiV5FirmsAppConnectionsDmsFileExports({
      app_key: 'gruntworx',
      source,
      document_ids: documentUuids ?? [requestUuid],
    });
    // GruntWorx always answers with the tracked export; the message-only
    // shape belongs to the folder-based DMS apps.
    return 'export_id' in result
      ? result
      : { success: false, export_id: '', message: result.message };
  },
  status: async (exportId) => {
    const status = await getApiV5FirmsAppConnectionsDmsFileExportsStatus({
      app_key: 'gruntworx',
      export_id: exportId,
    });
    return {
      ...status,
      started_at: status.started_at ?? undefined,
      completed_at: status.completed_at ?? undefined,
    };
  },
});

export const GRUNTWORX_REQUEST_EXPORT_ENDPOINTS = dmsGruntWorxExportEndpoints('Request');
